import React from 'react';
import clsx from 'clsx';

import makeStyles from '@material-ui/core/styles/makeStyles';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';

const buttonStyles = makeStyles((theme) => ({
    buttonWrapper: {
        position: 'relative',
        display: 'inline-flex'
    },
    defaultlight: {
        backgroundColor: theme.palette.greyFour.main,
        color: '#000',
        '&:hover': {
            backgroundColor: theme.palette.greyThree.main,
        }
    },
    defaultmain: {
        backgroundColor: theme.palette.greyThree.main,
        color: '#000',
        '&:hover': {
            backgroundColor: theme.palette.greyTwo.main,
        }
    },
    primarylight: {
        backgroundColor: theme.palette.primary.light,
        color: '#000',
        '&:hover': {
            backgroundColor: theme.palette.primary.main,
        }
    },
    primarymain: {
        backgroundColor: theme.palette.primary.main,
        color: '#000',
        '&:hover': {
            backgroundColor: theme.palette.primary.dark,
            color: '#FFF',
        }
    },
    secondarylight: {
        backgroundColor: theme.palette.secondary.light,
        color: '#000',
        '&:hover': {
            backgroundColor: theme.palette.secondary.main,
        }
    },
    secondarymain: {
        backgroundColor: theme.palette.secondary.main,
        color: '#000',
        '&:hover': {
            backgroundColor: theme.palette.secondary.dark,
            color: '#FFF',
        }
    },
    buttonProgress: {
        color: theme.palette.primary.main,
        position: 'absolute',
        top: '50%',
        left: '50%',
        marginTop: -11,
        marginLeft: -11,
    }
}))

export const FingotiButton = ({ children, loading, type, onClick, color, light, disabled, className, fullWidth, ...buttonProps }) => {

    const classes = buttonStyles();

    let shade = light ? "light" : "main"
    let classString = color + shade;

    return (
        <div className={clsx(classes.buttonWrapper, ...className)}>
            <Button
                fullWidth={fullWidth}
                variant='contained'
                disableElevation
                type={type}
                className={classes[classString]}
                onClick={onClick}
                disabled={disabled || loading}
                style={{ width: '100%' }}
                {...buttonProps}
            >
                {children}
            </Button>
            {
                loading &&
                <CircularProgress
                    size={22}
                    className={classes.buttonProgress}
                />
            }
        </div>
    );

}

FingotiButton.defaultProps = {
    type: "button",
    color: "default",
    fullWidth: false,
    light: false,
    disabled: false,
    loading: false
}